import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { registerAdmin } from '../../services/authService';
import { toast } from 'react-toastify';

interface SignupProps {
  onSignup: (email: string) => void;
}

export const Signup: React.FC<SignupProps> = ({ onSignup }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [responsibility, setResponsibility] = useState('');
  const [role, setRole] = useState('Admin');
  const [yearOfEmployment, setYearOfEmployment] = useState('');
  const navigate = useNavigate();


  const handleSignup = async (e: React.FormEvent) => {
  e.preventDefault();

  try {
    const payload = {
      email,
      first_name: firstName,
      last_name: lastName,
      password,
      phone_number: phoneNumber,
      responsibility,
      role,
      year_of_employment: yearOfEmployment,
    };

    const result = await registerAdmin(payload);

    // Your backend response is an array: [ { message: "...", ... }, code ]
    const responseMessage = result[0]?.message;
    const statusCode = result[1];

    // 🔍 Check if registration was successful
    if (statusCode === 201 && responseMessage === "User registered successfully") {
      toast.success("Account created successfully!");
      onSignup(email);
      navigate("/login");
    } else {
      // 🔥 Handle error message from backend
      toast.error(responseMessage || "Registration failed");
    }

  } catch (error: any) {
    console.error(error);
    if (error.response) {
      toast.error(error.response.data.message || "Registration failed");
    } else {
      toast.error("Network error");
    }
  }
};



//   const handleSignup = async (e: React.FormEvent) => {
//     e.preventDefault();

//     try {
//       const payload = {
//         email,
//         first_name: firstName,
//         last_name: lastName,
//         password,
//         phone_number: phoneNumber,
//         responsibility,
//         role,
//         year_of_employment: yearOfEmployment,
//       };

//       const result = await registerAdmin(payload);

//       toast.success('Account created successfully!');
//       console.log(result);

//       onSignup(email);
//       navigate('/login');
//     //   navigate('/dashboard');
//     } catch (error: any) {
//       console.error(error);
//       if (error.response) {
//         toast.error(error.response.data.message || 'Registration failed');
//       } else {
//         toast.error('Network error');
//       }
//     }
//   };

  return (
    <div className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Welcome, Create your account</h2>
        </div>
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="mb-6 text-sm text-gray-500">
            It is our great pleasure to have you on board!
          </div>

          <form className="space-y-6" onSubmit={handleSignup}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstName" className="sr-only">First Name</label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="lastName" className="sr-only">Last Name</label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="sr-only">Email address</label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                placeholder="Enter Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="password" className="sr-only">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="phone" className="sr-only">Phone Number</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  placeholder="Phone Number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="responsibility" className="sr-only">Responsibility</label>
                <input
                  id="responsibility"
                  name="responsibility"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  placeholder="Responsibility"
                  value={responsibility}
                  onChange={(e) => setResponsibility(e.target.value)}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="role" className="sr-only">Role</label>
                <select
                  id="role"
                  name="role"
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="Admin">Admin</option>
                  <option value="SuperAdmin">SuperAdmin</option>
                </select>
              </div>

              <div>
                <label htmlFor="yoe" className="sr-only">Year of Employment</label>
                <input
                  id="yoe"
                  name="yoe"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  placeholder="Year of Employment"
                  value={yearOfEmployment}
                  onChange={(e) => setYearOfEmployment(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                Create Account
              </button>
            </div>
          </form>

          <div className="mt-6">
            <div className="relative">
              <div className="relative flex justify-center text-sm">
                <span className="bg-white px-2 text-gray-500">
                  Already have an account? <Link to="/login" className="font-medium text-primary hover:text-indigo-800">Log in</Link>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
